export default __webpack_public_path__ + "static/media/Slide1.3c4ef642.JPG";